import React, { useState } from 'react'
import "../App.css"
import { useDispatch, useSelector } from 'react-redux'
import { login } from '../redux/login/login.action'
const Login = () => {
    const [name,setname]=useState("")
    const [email,setemail]=useState("")
    const dispatch=useDispatch()
    const username=useSelector(state=>state.login.name)
    function handleclick(){
        if(name===""||email===""){
            alert("please enter all credentials")
        }else{
            dispatch(login({name,email}))
        }
  
    }
  return (
    <div className='login'>
        <center style={{color:"red",fontSize:"19px"}}>Welcome {username==="unknown"?"":username}</center>
        <input type="text" placeholder='Enter your name'  onChange={(e)=>setname(e.target.value)} />
        <input type="email" placeholder='enter your email' onChange={(e)=>setemail(e.target.value)}  />
        <input type="submit" value={"Login"} onClick={handleclick} />
      

    </div>
  )
}

export default Login